import {CREATEDIABETES, FETCH_ALLDIABETES, UPDATEDIABETES, DELETEDIABETES} from '../constants/actionTypes';
export default (diabetesposts = [], action) =>{
    switch (action.type){
        case FETCH_ALLDIABETES:
            return action.payload;
        case CREATEDIABETES:
            return [... diabetesposts, action.payload];  
        case UPDATEDIABETES:
            return diabetesposts.map((diabetespost) => diabetespost._id === action.payload._id ? action.payload : diabetespost);
        case DELETEDIABETES:
            return diabetesposts.filter((diabetespost) => diabetespost._id !== action.payload);
        default:
            return diabetesposts;      
    }
}